import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { FaPlus, FaTrash, FaCog } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import toastify CSS
import { useModal } from "../../Hooks/modalContext";
import SymbolForm from "../../Components/Database/SymbolForm";
// import DialogDefault from '../Services/Modal';
import { TiTick } from "react-icons/ti";
import ReactQuill from "react-quill";

const ProductDBForm = () => {
  const [ingredients, setIngredients] = useState([
    {
      ing_name: "",
      ing_item_code: "",
      seq_no: 0,
      other_ing: 0,
      per_composition: 0,
      alpha_composition: "",
      suggestedIngredients: [],
      suggestedItemCodes: [],
    },
  ]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [productId, setProductId] = useState("");
  const [productName, setProductName] = useState("");

  // Symbol states
  const [symbolData, setSymbolData] = useState([]);
  const [selectedSymbols, setSelectedSymbols] = useState([
    { symbol: "0", symbol_code: "0000", symbol_id: 0 },
  ]);

  // Identified Uses states
  const [identifiedUsesData, setIdentifiedUsesData] = useState([]);
  const [identifiedUses, setIdentifiedUses] = useState("");
  const [customIdentifiedUses, setCustomIdentifiedUses] = useState("");
  const [showIdentifiedInput, setShowIdentifiedInput] = useState(false);

  // Mixtures Uses states
  const [mixturesData, setMixturesData] = useState([]);
  const [mixtures, setMixtures] = useState("");
  const [customMixtures, setCustomMixtures] = useState("");
  const [showMixturesInput, setShowMixturesInput] = useState(false);

  // Appearance Data states
  const [appearanceData, setAppearanceData] = useState([]);
  const [appearance, setAppearance] = useState("");
  const [customAppearance, setCustomAppearance] = useState("");
  const [showAppearanceInput, setShowAppearanceInput] = useState(false);

  // Color states
  const [colorData, setColorData] = useState([]);
  const [color, setColor] = useState("");
  const [customColor, setCustomColor] = useState("");
  const [showColorInput, setShowColorInput] = useState(false);

  const [debouncedTerm, setDebouncedTerm] = useState("");
  const [activeDropdownIndex, setActiveDropdownIndex] = useState(null);

  const [isInsertingSymbol, setIsInsertingSymbol] = useState(false);

  const navigate = useNavigate();

  const addIngredient = () => {
    const newIngredient = {
      ing_name: "",
      ing_item_code: "",
      seq_no: ingredients.length + 1, // Set seq_no based on the total number of ingredients (i.e., ingredients.length + 1)
      other_ing: 0,
      per_composition: 0,
      alpha_composition: "",
      suggestedIngredients: [],
      suggestedItemCodes: [],
    };
    setIngredients([...ingredients, newIngredient]);
  };

  //
  // const [isOpen, setIsOpen ] = useModal();
  const { openModal } = useModal();

  const quillRefs = useRef([]);

  const handleClick = (e) => {
    openModal(<SymbolForm />);
  };

  // Fetch identified-use, mixtures, colors, appearance data

  const fetchData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URI}/elixir/all-info`
      );

      if (res.status !== 200) {
        throw new Error("Unable to fetch data, please reload page");
      }

      setIdentifiedUsesData(res.data.identified_uses);
      setMixturesData(res.data.mixtures);
      setAppearanceData(res.data.appearance);
      setColorData(res.data.color);
      setSymbolData(res.data.symbols || []);
    } catch (error) {
      let errorMessage = "Something went wrong. Please try again.";

      if (error.response) {
        // API responded with an error status (e.g., 400, 401, 403, 404, 500)
        errorMessage = `Error ${error.response.status}: ${
          error.response.data?.detail || "Request failed"
        }`;
      } else if (error.request) {
        // No response received (Network issue)
        errorMessage = "Network error. Please check your internet connection.";
      } else {
        // Other unexpected errors
        errorMessage = "Unexpected error occurred.";
      }
      console.error(errorMessage);
      console.error("Fetch error:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (debouncedTerm.length > 0) {
        // Fetch suggested item codes for the specific ingredient row
        fetch(`${process.env.REACT_APP_BASE_URI}/elixir/fetch_ingredient`, {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        })
          .then((response) => response.json())
          .then((data) => {
            const ingredientsList = data.data || [];

            const filteredSuggestions = ingredientsList
              .map((ingredient) => ({
                name: ingredient.ing_name,
                itemCode: ingredient.ing_item_code,
              }))
              .filter(
                (option) =>
                  option.itemCode &&
                  option.itemCode
                    .toLowerCase()
                    .includes(debouncedTerm.toLowerCase())
              );

            // const updatedIngredients = [...ingredients];
            // updatedIngredients.forEach((element, index)=>{
            //     if (element.ing_item_code.toLowerCase() === debouncedTerm.toLowerCase()) {
            //         updatedIngredients[index].suggestedItemCodes = filteredSuggestions;
            //     }
            // })

            setIngredients((prev) =>
              prev.map((ingredient) =>
                ingredient.ing_item_code === debouncedTerm
                  ? { ...ingredient, suggestedItemCodes: filteredSuggestions }
                  : ingredient
              )
            );

            // setIngredients([...values]);
          })
          .catch((error) =>
            console.error("Error fetching suggested item codes:", error)
          );
      } else {
        setIngredients((prev) =>
          prev.map((ingredient) =>
            ingredient.ing_item_code === debouncedTerm
              ? { ...ingredient, ing_name: "", suggestedItemCodes: [] }
              : ingredient
          )
        );
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [debouncedTerm]);

  const handleIngredientChange = (index, e) => {
    const value = e.target.value;
    const values = [...ingredients];
    values[index][e.target.name] = value;

    // Check if the field being changed is 'itemCode'
    if (e.target.name === "ing_item_code") {
      setDebouncedTerm(value);

      // if (value.length === 0) {
      //     values[index].ing_name = ''; // Clear the ingredient name
      //     values[index].suggestedItemCodes = [];
      //     setIngredients([...values]);
      // }
      setActiveDropdownIndex(index);
    } else if (e.target.name === "other_ing") {
      values[index][e.target.name] = e.target.checked ? 1 : 0;
      // setIngredients([...values]);  // Update state
    }
    setIngredients([...values]);
  };
  // if (value.length > 2) {
  //     // Fetch suggested item codes for the specific ingredient row
  //     fetch(`${process.env.REACT_APP_BASE_URI}/elixir/fetch_ingredient`, {
  //         method: 'GET', headers: {
  //             Accept: 'application/json',
  //         },
  //     })
  //         .then((response) => response.json())
  //         .then((data) => {
  //             const ingredientsList = data.data || [];
  //

  //             const filteredSuggestions = ingredientsList
  //                 .map((ingredient) => ({
  //                     name: ingredient.ing_name, itemCode: ingredient.ing_item_code,
  //                 }))
  //                 .filter((option) => option.itemCode && option.itemCode.toLowerCase().includes(value.toLowerCase()));

  //

  //             values[index].suggestedItemCodes = filteredSuggestions;

  //

  //             setIngredients([...values]);
  //         })
  //         .catch((error) => console.error('Error fetching suggested item codes:', error));
  // } else {
  //     // If itemCode is cleared, set ingredient to empty
  //     values[index].ing_name = ''; // Clear the ingredient name
  //     values[index].suggestedItemCodes = [];
  //     setIngredients([...values]);
  // }

  const handleSuggestionSelect = (index, suggestion, field) => {
    // Ensure the ingredient exists at the specified index
    if (index >= 0 && index < ingredients.length) {
      const values = [...ingredients];
      if (field === "itemCode") {
        // Check if ingredient exists before trying to set its properties
        if (values[index]) {
          values[index].ing_item_code = suggestion.itemCode;
          values[index].ing_name = suggestion.name; // Automatically set ingredient name
          values[index].suggestedItemCodes = []; // Clear the suggestions
        }
      } else {
        // This block may not be needed anymore since ingredient is non-editable
        values[index][field] = suggestion;
        values[index].suggestedIngredients = [];
      }
      setIngredients(values);
      setActiveDropdownIndex(null);
    } else {
      console.error("Invalid index:", index);
    }
  };

  const removeIngredient = (index) => {
    const values = [...ingredients];
    values.splice(index, 1);
    setIngredients(values);
  };

  //Handle dropdowns
  const handleDropDown = (
    value,
    setShowInput,
    setSelectedValue,
    setCustomInput,
    name
  ) => {
    if (value === "Other") {
      setShowInput(true);
      setSelectedValue("");
    } else {
      setShowInput(false);
      setCustomInput("");
      setSelectedValue(value);
    }
  };

  const handleInputEvent = (
    e,
    customInput,
    setSelectedValue,
    setShowInput,
    name
  ) => {
    if (e.key === "Enter" && customInput.trim()) {
      let customValue = customInput.trim();
      setSelectedValue(customValue);
      setShowInput(false);
    }
  };

  // Send data to backend

  const handleUpload = async (event) => {
    event.preventDefault();

    if (ingredients.length === 0) {
      toast.error("Please add at least one ingredient before submitting");
    }

    const hasEmptyIngredient = ingredients.some(
      (ingredient) => ingredient.ing_name.trim() === ""
    );
    if (hasEmptyIngredient) {
      toast.error("All ingredient names must be filled out.");
      return; // Prevent form submission
    }

    const ingredientsArray = ingredients.map((ingredient, index) => ({
      ing_item_code: ingredient.ing_item_code
        ? ingredient.ing_item_code.trim()
        : "",
      ing_name: ingredient.ing_name.trim(),
      seq_no: index + 1,
      other_ing: ingredient.other_ing,
      per_composition: Number(ingredient.per_composition) || 0,
      alpha_composition: ingredient.alpha_composition.trim(),
    }));

    const data = {
      data: {
        product_id: productId.trim(),
        ingredients: ingredientsArray,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      },
      data1: {
        product_id: productId.trim(),
        product_name: productName.trim(),
        symbol_id: selectedSymbols[0].symbol_id || 0,
        identified_uses_of_application: identifiedUses.trim(),
        mixtures_of_application: mixtures.trim(),
        product_appearance: appearance.trim(),
        product_color: color.trim(),
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      },
    };

    const isValidIngredients = ingredientsArray.every(
      (ingredient) =>
        /^[A-Z0-9\W_]+$/u.test(ingredient.ing_item_code) &&
        !isNaN(ingredient.per_composition) &&
        ingredient.per_composition >= 0 &&
        ingredient.per_composition <= 100
    );

    if (!isValidIngredients) {
      alert(
        "Invalid ingredient details. Please check item codes and compositions."
      );
      return;
    }

    try {
      // New PUT request to the single API endpoint
      const putResponse = await fetch(
        `${process.env.REACT_APP_BASE_URI}/elixir/product_composition`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      if (!putResponse.ok) {
        const errorData = await putResponse.json();

        if (errorData.detail.includes("Duplicate entry")) {
          toast.error(
            "❌ Duplicate Item Code or Product ID! Please check inputs before submitting."
          );
          return;
        }
        toast.error(
          `Error in PUT request: ${errorData.detail || "Unknown error"}`
        );
        throw new Error(
          `HTTP error! status: ${putResponse.status}, ${JSON.stringify(
            errorData
          )}`
        );
      }

      toast.success("Product composition added successfully!");
      setTimeout(() => {
        navigate("/database");
      }, 3000);
    } catch (error) {
      console.error("Error uploading data:", error);
      // Parse response JSON properly

      if (error.message.includes("Failed to fetch")) {
        toast.error("Network error! Please check your connection.");
      } else if (error.response) {
        try {
          const errorData = await error.response.json(); // Ensure JSON parsing
          const errorDetail = errorData?.detail || "";

          if (error.response.status === 422) {
            toast.error("Validation failed! Please check your inputs.");
          } else if (
            error.response.status === 400 ||
            error.response.status === 500
          ) {
            if (errorDetail.includes("Duplicate entry")) {
              if (errorDetail.includes("for key 'items.PRIMARY'")) {
                toast.error(
                  "❌ Duplicate Item Code! Each item code must be unique for the selected product."
                );
              } else if (errorDetail.includes("for key 'products.PRIMARY'")) {
                toast.error(
                  "❌ Duplicate Product ID! Each product must have a unique identifier."
                );
              } else {
                toast.error(
                  "❌ Duplicate entry detected! Please ensure all values are unique."
                );
              }
            } else {
              toast.error("Server error! Please try again later.");
            }
          } else {
            toast.error(
              `Error ${error.response.status}: ${error.response.statusText}`
            );
          }
        } catch (parseError) {
          console.error("Error parsing response:", parseError);
          toast.error("Unexpected server response. Please try again.");
        }
      } else {
        toast.error("Error uploading data");
      }
    }
  };

  // Create a dynamic regex based on the symbols in symbolData
  const createSymbolRegex = (symbols) => {
    const escapedSymbols = symbols
      .filter((s) => s.symbol.length > 1 || /[^\d]/.test(s.symbol)) // Exclude pure digits like "0"
      .map((s) => s.symbol.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
    // .map((s) =>
    //   s.symbol.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    // );
    return new RegExp(escapedSymbols.join("|"), "g"); //TM|C|0
  };

  const sanitizeHtmlContent = (html, symbolRegex) => {
    return html
      .replace(/<span\s+class=["']ql_cursor["']\s*><\/span>/g, "") // Remove cursor spans
      .replace(/[\u00A0\u200B\uFEFF]/g, "") // Remove invisible spaces
      .replace(new RegExp(`\\s+(?=${symbolRegex.source})`, "g"), ""); // Remove space before symbol
  };

  const placeholderSymbol = { symbol: "0", symbol_code: "0000", symbol_id: 0 };

  const handleSymbolChange = (symbolObj, index) => {
    // setSelectedSymbols((prevSelected) => {
    //   const isSelected = prevSelected.some(
    //     (s) => s.symbol_id === symbolObj.symbol_id
    //   );

    //   // console.log("IsSelected", isSelected);

    //   const quillInstance = quillRefs.current[index]?.getEditor();
    //   if (!quillInstance) return prevSelected;

    //   // Get current plain text (not HTML or Delta)
    //   const symbolRegex = createSymbolRegex(symbolData);
    //   const plainText = quillInstance.getText().trim();

    //   // 1. Remove any symbol at the end
    //   const match = plainText.match(symbolRegex);
    //   if (match) {
    //     const matchSymbol = match[0];
    //     const matchIndex = plainText.lastIndexOf(matchSymbol);
    //     const endIndex = matchIndex + matchSymbol.length;
    //     if (endIndex >= plainText.trimEnd().length) {
    //       quillInstance.deleteText(matchIndex, matchSymbol.length);
    //     }
    //   }

    //   const cursorIndex = quillInstance.getSelection()?.index
    //   console.log("Isselected: ", isSelected);

    //   if (!isSelected) {
    //     setIsInsertingSymbol(true);
    //     const rawCode = symbolObj?.symbol_code;
    //     const codePoint = parseInt(rawCode, 16); // <-- base 16 (hex)

    //     if (Number.isInteger(codePoint) && codePoint > 0) {
    //       const char = String.fromCodePoint(codePoint);
    //       // console.log("✅ Inserting:", char, "from hex:", rawCode);
    //       quillInstance.insertText(cursorIndex, char, "user");
    //       quillInstance.setSelection(cursorIndex + 1, 0);
    //     }

    //     // Clean and update product name
    //     const rawHTML = quillInstance.root.innerHTML;
    //     const cleanHTML = sanitizeHtmlContent(rawHTML, symbolRegex);
    //     setProductName(cleanHTML);

    //     // console.log("Symbol Obj", symbolObj);
    //     setIsInsertingSymbol(true);
    //     return [symbolObj];
    //   } else {
    //     setProductName(quillInstance.root.innerHTML);
    //     return [{ symbol: "0", symbol_code: "0000", symbol_id: 0 }];
    //   }
    // });

    const quillInstance = quillRefs.current[index]?.getEditor();
    if (!quillInstance) return;

    quillInstance.focus();
    const selection = quillInstance.getSelection();
    const cursorIndex = selection?.index ?? quillInstance.getLength();

    const isSelected = selectedSymbols.some(
      (s) => s.symbol_id === symbolObj.symbol_id
    );

    setIsInsertingSymbol(true);

    if (!isSelected) {
      // Select new symbol
      setSelectedSymbols([symbolObj]);

      // Remove previous symbols and trailing newline
      let fullText = quillInstance.getText();
      if (fullText.endsWith("\n")) fullText = fullText.slice(0, -1);
      const textWithoutSymbols = fullText
        .replace(createSymbolRegex(symbolData), "")
        .trim();

      quillInstance.setText(textWithoutSymbols);

      // Insert new symbol at cursor
      const rawCode = symbolObj?.symbol_code;
      const codePoint = parseInt(rawCode, 16);
      if (!Number.isInteger(codePoint) || codePoint <= 0) {
        console.warn("Invalid hex symbol_code:", rawCode);
        setIsInsertingSymbol(false);
        return;
      }
      const char = String.fromCodePoint(codePoint);
      const insertIndex = Math.min(cursorIndex, textWithoutSymbols.length);
      quillInstance.insertText(insertIndex, char, "user");
      quillInstance.setSelection(insertIndex + char.length, 0); // Cursor after symbol

      // Update product name
      const rawHTML = quillInstance.root.innerHTML;
      const cleanHTML = sanitizeHtmlContent(
        rawHTML,
        createSymbolRegex(symbolData)
      );
      setProductName(cleanHTML);
    } else {
      // Deselect symbol
      setSelectedSymbols([placeholderSymbol]);

      // Remove existing symbol
      let fullText = quillInstance.getText();
      if (fullText.endsWith("\n")) fullText = fullText.slice(0, -1);
      const textWithoutSymbols = fullText
        .replace(createSymbolRegex(symbolData), "")
        .trim();

      quillInstance.setText(textWithoutSymbols);

      // Update product name
      const rawHTML = quillInstance.root.innerHTML;
      const cleanHTML = sanitizeHtmlContent(
        rawHTML,
        createSymbolRegex(symbolData)
      );
      setProductName(cleanHTML);
    }

    setIsInsertingSymbol(false);
  };

  // Update Product Name Field with theq Selected Symbol
  // const updateProductName = (symbolObj) => {
  //     let baseName = productName.replace(/™|®/g, "").trim(); // Remove existing symbols
  //     let newProductName = symbolObj ? `${baseName} ${symbolObj.symbol}` : baseName;
  //     setProductName(newProductName.trim());
  // };

  // const handleProductNameChange = (e) => {
  //     const baseName = e.target.value.replace(/™|®/g, ''); // Remove existing symbols
  //     setProductName(baseName); // Set only the base name
  // };

  const getPlainTextFromQuill = (htmlContent) => {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = htmlContent;
    return tempElement.textContent || tempElement.innerText || "";
  };

  const handleProductNameChange = (htmlContent) => {
    if (isInsertingSymbol) {
      console.log("Currently inserting symbol, skipping...");
      return;
    }
    // Step 1: Remove invisible characters and ql_cursor spans
    let cleanedHtml = htmlContent
      .replace(/<span\s+class=["']ql_cursor["']\s*><\/span>/g, "")
      .replace(/[\u00A0\u200B\uFEFF]/g, "")
      .replace(/\s+(?=(${createSymbolRegex(symbolData).source}))/g, ""); // Remove space before symbols

    // Step 2: Get plain text for validation
    const plainText = getPlainTextFromQuill(cleanedHtml).trim();
    // Enforce single symbol
  const symbolMatches = plainText.match(createSymbolRegex(symbolData));
  if (symbolMatches && symbolMatches.length > 1) {
    const firstSymbol = symbolMatches[0];
    const firstSymbolIndex = plainText.indexOf(firstSymbol);
    let updatedText = plainText.substring(
      0,
      firstSymbolIndex + firstSymbol.length
    );
    for (let i = 1; i < symbolMatches.length; i++) {
      updatedText = updatedText.replace(symbolMatches[i], "");
    }
    const quillInstance = quillRefs.current[0]?.getEditor();
    if (quillInstance) {
      quillInstance.setText(updatedText);
      cleanedHtml = quillInstance.root.innerHTML;
    }
  }

  // Update selectedSymbols based on text content
  const symbolMatch = symbolMatches ? symbolMatches[0] : null;
  if (symbolMatch) {
    const foundSymbol = symbolData.find(
      (symbolObj) => symbolMatch === symbolObj.symbol
    );
    if (
      foundSymbol &&
      foundSymbol.symbol_id !== selectedSymbols[0]?.symbol_id
    ) {
      setSelectedSymbols([foundSymbol]);
    }
  } else if (selectedSymbols[0]?.symbol_id !== placeholderSymbol.symbol_id) {
    setSelectedSymbols([placeholderSymbol]);
  }

  // Update product name
  setProductName(cleanedHtml);
  };

  const handleBack = () => {
    navigate("/database");
  };

  const handleDatabase = () => {
    navigate("/database");
  };

  function stripHtmlTags(html) {
    const temp = document.createElement("div");
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || "";
  }

  return (
    <div className="bg-gray-900 min-h-screen text-gray-200 p-8">
      <ToastContainer theme="dark" />
      <nav className="navbar bg-gray-800 text-white p-4 flex justify-between">
        <h1 className="text-2xl font-bold">Elixir</h1>
        <div className="relative">
          <button
            onClick={() => setShowDropdown(!showDropdown)}
            className="text-white font-bold py-2 px-4 rounded"
            title="Settings"
          >
            <FaCog />
          </button>
          {showDropdown && (
            <ul className="absolute right-0 mt-2 w-48 bg-gray-700 text-white rounded shadow-lg z-20">
              <li
                onClick={handleDatabase}
                className="py-2 px-4 hover:bg-gray-600 cursor-pointer"
              >
                Database
              </li>
            </ul>
          )}
        </div>
      </nav>

      {/*  */}
      <div className="p-8 bg-gray-800 rounded-lg mt-6">
        <div>
          <button
            onClick={handleBack}
            type="button"
            class="bg-gray-900 mb-6 relative top left-0 text-white py-2 px-4 rounded shadow "
          >
            Back
          </button>
        </div>

        <h2 className="text-xl font-bold mb-4">Product Form</h2>
        <form className="space-y-6" onSubmit={handleUpload}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex flex-col">
              <label className="font-semibold">Product ID</label>
              <input
                type="text"
                value={productId}
                onChange={(e) => setProductId(e.target.value)}
                maxLength={15}
                className="border p-2 rounded bg-gray-700"
                required
              />
            </div>

            <div className="flex flex-col">
              <label className="font-semibold">Product Name</label>

              <div>
                <ReactQuill
                  ref={(el) => (quillRefs.current[0] = el)}
                  name="ing_name"
                  value={productName || ""}
                  onChange={(content) => handleProductNameChange(content)}
                  theme="snow"
                  // className="bg-gray-500 text-white  w-full "
                  className=" text-gray-200 w-full"
                  required
                />
              </div>
              <div className="flex flex-wrap gap-4">
                {symbolData.length > 0 ? (
                  symbolData
                    .filter((item) => item.symbol_id !== 0)
                    .map((symbolObj) => (
                      <label
                        key={symbolObj.symbol_id}
                        className="flex items-center space-x-2"
                      >
                        <input
                          type="checkbox"
                          name="symbol"
                          checked={
                            selectedSymbols.length > 0 &&
                            selectedSymbols.some(
                              (selected) =>
                                selected.symbol_id === symbolObj.symbol_id
                            )
                          }
                          placeholder={<TiTick />}
                          onChange={() => handleSymbolChange(symbolObj, 0)}
                          className={`rounded-[100%] appearance-none color-white w-3 h-3 bg-white checked:bg-blue-500`}
                        />
                        <span className="text-xl">{symbolObj.symbol}</span>
                      </label>
                    ))
                ) : (
                  <p className="text-gray-400">No symbols available</p>
                )}
                <button
                  type="button"
                  onClick={() => handleClick()}
                  className="bg-blue-500 w-10 rounded-full mt-1"
                >
                  +
                </button>
              </div>
              {/* <button
                            className="mt-4 p-2 bg-blue-500 text-white rounded"
                            onClick={() => {
                          
                            }}
                        >
                            Submit
                        </button> */}
            </div>

            {/* Identified Uses Dropdown */}
            <div className="flex flex-col">
              <label className="font-semibold">Identified Uses</label>
              <select
                className="border p-2 rounded bg-gray-700"
                value={showIdentifiedInput ? "Other" : identifiedUses}
                onChange={(e) =>
                  handleDropDown(
                    e.target.value,
                    setShowIdentifiedInput,
                    setIdentifiedUses,
                    setCustomIdentifiedUses
                  )
                }
              >
                <option value="">Select</option>
                {identifiedUsesData.map((currElem, idx) => {
                  return (
                    <option value={currElem} key={idx}>
                      {currElem}
                    </option>
                  );
                })}
                <option value="Other">Other</option>
                {/* 
                        <option value="Biocatalyst in industry">Biocatalyst in industry</option>
                        <option value="Other">Other (please specify)</option> */}
              </select>

              {showIdentifiedInput && (
                <input
                  type="text"
                  value={customIdentifiedUses}
                  onChange={(e) => setCustomIdentifiedUses(e.target.value)}
                  onKeyDown={(e) =>
                    handleInputEvent(
                      e,
                      customIdentifiedUses,
                      setIdentifiedUses,
                      setShowIdentifiedInput
                    )
                  }
                  className="border p-2 rounded bg-gray-700 mt-2"
                  placeholder="Enter custom value"
                  autoFocus
                />
              )}
              {identifiedUses &&
                !identifiedUsesData.includes(identifiedUses) &&
                !showIdentifiedInput && (
                  <span className="mt-2 text-gray-300 ">
                    Selected:{" "}
                    <span className="text-xl font-bold">{identifiedUses}</span>{" "}
                  </span>
                )}
            </div>

            {/* Mixtures: Synonyms Dropdown */}
            <div className="flex flex-col">
              <label className="font-semibold">Mixtures: Synonyms</label>
              <select
                className="border p-2 rounded bg-gray-700"
                value={showMixturesInput ? "Other" : mixtures}
                onChange={(e) =>
                  handleDropDown(
                    e.target.value,
                    setShowMixturesInput,
                    setMixtures,
                    setCustomMixtures
                  )
                }
              >
                <option value="">Select</option>
                {mixturesData.map((currElem, index) => {
                  return (
                    <option value={currElem} key={index}>
                      {currElem}
                    </option>
                  );
                })}
                <option value="Other">Other (please specify)</option>
              </select>

              {showMixturesInput && (
                <input
                  type="text"
                  value={customMixtures}
                  onChange={(e) => setCustomMixtures(e.target.value)}
                  onKeyDown={(e) =>
                    handleInputEvent(
                      e,
                      customMixtures,
                      setMixtures,
                      setShowMixturesInput
                    )
                  }
                  className="border p-2 rounded bg-gray-700 mt-2"
                  placeholder="Enter custom value"
                  autoFocus
                />
              )}

              {mixtures &&
                !mixturesData.includes(mixtures) &&
                !showMixturesInput && (
                  <span className="mt-2 text-gray-300 ">
                    Selected:{" "}
                    <span className="text-xl font-bold">{mixtures}</span>{" "}
                  </span>
                )}
            </div>

            {/* Appearance Dropdown */}
            <div className="flex flex-col">
              <label className="font-semibold">Appearance</label>
              <select
                className="border p-2 rounded bg-gray-700"
                value={showAppearanceInput ? "Other" : appearance}
                onChange={(e) =>
                  handleDropDown(
                    e.target.value,
                    setShowAppearanceInput,
                    setAppearance,
                    setCustomAppearance
                  )
                }
              >
                <option value="">Select</option>
                {appearanceData.map((currElem, index) => {
                  return (
                    <option value={currElem} key={index}>
                      {currElem}
                    </option>
                  );
                })}
                <option value="Other">Other (please specify)</option>
              </select>

              {showAppearanceInput && (
                <input
                  type="text"
                  value={customAppearance}
                  onChange={(e) => setCustomAppearance(e.target.value)}
                  onKeyDown={(e) =>
                    handleInputEvent(
                      e,
                      customAppearance,
                      setAppearance,
                      setShowAppearanceInput
                    )
                  }
                  className="border p-2 rounded bg-gray-700 mt-2"
                  placeholder="Enter custom value"
                  autoFocus
                />
              )}

              {appearance &&
                !appearanceData.includes(appearance) &&
                !showAppearanceInput && (
                  <span className="mt-2 text-gray-300 ">
                    Selected:{" "}
                    <span className="text-xl font-bold">{appearance}</span>{" "}
                  </span>
                )}
            </div>

            {/* Colour Dropdown */}
            <div className="flex flex-col">
              <label className="font-semibold">Colour</label>
              <select
                className="border p-2 rounded bg-gray-700"
                value={showColorInput ? "Other" : color}
                onChange={(e) =>
                  handleDropDown(
                    e.target.value,
                    setShowColorInput,
                    setColor,
                    setCustomColor
                  )
                }
              >
                <option value="">Select</option>
                {colorData.map((currElem, index) => {
                  return (
                    <option value={currElem} key={index}>
                      {currElem}
                    </option>
                  );
                })}
                <option value="Other">Other (please specify)</option>
              </select>
              {showColorInput && (
                <input
                  type="text"
                  value={customColor}
                  onChange={(e) => setCustomColor(e.target.value)}
                  onKeyDown={(e) =>
                    handleInputEvent(
                      e,
                      customColor,
                      setColor,
                      setShowColorInput
                    )
                  }
                  className="border p-2 rounded bg-gray-700 mt-2"
                  placeholder="Enter custom value"
                  autoFocus
                />
              )}

              {color && !colorData.includes(color) && !showColorInput && (
                <span className="mt-2 text-gray-300 ">
                  Selected: <span className="text-xl font-bold">{color}</span>{" "}
                </span>
              )}
            </div>
          </div>

          <div className="flex justify-center">
            <hr className="border-dotted size-6 text-center border-t-8" />
          </div>

          {/* Ingredients Array  */}
          {ingredients.map((ingredient, index) => (
            <div
              key={index}
              className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-6 items-center"
            >
              {/* Item Code comes before Ingredient */}
              <div className="flex flex-col relative">
                <label className="font-semibold whitespace-nowrap h-10 leading-none">
                  Item Code
                </label>
                <input
                  type="text"
                  name="ing_item_code"
                  value={ingredient.ing_item_code}
                  onChange={(e) => handleIngredientChange(index, e)}
                  className="border p-2 rounded bg-gray-700"
                  required
                />

                {index === activeDropdownIndex &&
                  ingredient.suggestedItemCodes.length > 0 && (
                    <ul className="bg-gray-800 border border-gray-700 mt-1 max-h-32 overflow-y-auto absolute top-20 w-full z-30">
                      {ingredient.suggestedItemCodes.map((suggested, idx) => (
                        <li
                          key={idx}
                          className="p-2 hover:bg-gray-600 cursor-pointer"
                          onClick={() =>
                            handleSuggestionSelect(index, suggested, "itemCode")
                          }
                          dangerouslySetInnerHTML={{
                            __html: `${suggested.itemCode} - ${suggested.name}`,
                          }}
                        ></li>
                      ))}
                    </ul>
                  )}
              </div>

              <div className="flex flex-col relative">
                <label className="font-semibold h-10 pb-2 leading-none">
                  Ingredient
                </label>
                <input
                  type="text"
                  name="ing_name"
                  value={stripHtmlTags(ingredient.ing_name)}
                  onChange={(e) => handleIngredientChange(index, e)}
                  className="border p-2 rounded bg-gray-700"
                  required
                  readOnly // Make this field read-only to prevent editing
                />
              </div>

              <div className="flex flex-col relative">
                <label className="font-semibold flex h-10 leading-none pb-2">
                  Composition in Numerical
                </label>
                <input
                  type="number"
                  name="per_composition"
                  value={ingredient.per_composition}
                  onChange={(e) => handleIngredientChange(index, e)}
                  className="border p-2 rounded bg-gray-700"
                  required
                />
              </div>

              <div className="flex flex-col">
                <label htmlFor="" className="font-semibold h-10 leading-none">
                  Percentage Composition
                </label>
                <input
                  type="text"
                  name="alpha_composition"
                  value={ingredient.alpha_composition}
                  onChange={(e) => handleIngredientChange(index, e)}
                  className="border p-2 rounded bg-gray-700"
                />
              </div>

              <div class="flex items-center mt-9 ps-2 border border-gray-200 rounded-md dark:border-gray-700">
                <input
                  id="bordered-checkbox-1"
                  type="checkbox"
                  name="other_ing"
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  checked={ingredient.other_ing}
                  onChange={(e) => handleIngredientChange(index, e)}
                />

                <label
                  htmlFor="bordered-checkbox-1"
                  className=" py-3 ms-2 text-sm font-medium text-white dark:text-gray-300"
                >
                  Other Ingredient
                </label>
              </div>

              <div className="flex items-center">
                <button
                  type="button"
                  onClick={() => removeIngredient(index)}
                  className="mt-6 bg-red-500 text-white rounded p-2"
                >
                  <FaTrash />
                </button>
              </div>
            </div>
          ))}

          <button
            type="button"
            onClick={addIngredient}
            className="bg-blue-500 hover:bg-blue-700 text-white rounded p-2 flex items-center gap-2 font-semibold"
          >
            <FaPlus />
            Add Ingredient
          </button>

          <button
            type="submit"
            className="bg-green-500 text-white rounded p-2 w-full"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default ProductDBForm;
